import { render, staticRenderFns } from "./ShiftPopover.vue?vue&type=template&id=05bdf275&lang=html&"
import script from "./ShiftPopover.vue?vue&type=script&lang=js&"
export * from "./ShiftPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports